var _jsxFileName = "/home/runner/_work/smpackages/smpackages/packages/webassets/src/components/Header/components/Addon/SeatUpgradeButton.js",
  _this = this;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from 'react';
import { Button } from '@sm/wds-react';
import { defineMessages, T } from '@sm/intl';
import SeatRequestModal from '../../../SeatRequestModal';
export var COPY = defineMessages({
  SEAT_REQUEST: {
    id: 'SeatUpgradeButton.SeatRequest',
    defaultMessage: 'REQUEST POWER SEAT',
    description: '[Type: Label][Vis.: high] - This is a button for users to request a seat upgrade.'
  }
});
var SeatUpgradeButton = function SeatUpgradeButton() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showModal = _useState2[0],
    setShowModal = _useState2[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    "data-testid": "Addon__SeatUpgradeBtn",
    color: "alt",
    size: "sm",
    disabled: showModal,
    onClick: function onClick() {
      setShowModal(true);
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.SEAT_REQUEST,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement(SeatRequestModal, {
    show: showModal,
    onClose: function onClose() {
      return setShowModal(false);
    },
    sourceCategoryKey: "global_header",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 7
    }
  }));
};
export default SeatUpgradeButton;
//# sourceMappingURL=SeatUpgradeButton.js.map